<template>
  <tbody class="cxm-TableBody">
    <slot />
  </tbody>
</template>

<script>
export default {
  name: 'TableBody',
};
</script>

<style lang="scss" scoped>
.cxm-TableBody {
  border: solid var(--track-color-bluegray-20);
  border-width: 0 var(--track-border-sm);
}
</style>
